import type { paths } from '@cortex/api-client';

// Response and request shapes of the identity routes, from the generated client.
type Json<Op> = Op extends { responses: { 200: { content: { 'application/json': infer R } } } }
  ? R
  : Op extends { responses: { 201: { content: { 'application/json': infer R } } } }
    ? R
    : never;

export type Org = Json<paths['/api/orgs']['get']>['orgs'][number];
export type OrgDetail = Json<paths['/api/orgs/{slug}']['get']>;
export type Member = Json<paths['/api/orgs/{slug}/members']['get']>['members'][number];
export type Invitation = Json<paths['/api/orgs/{slug}/invitations']['get']>['invitations'][number];
export type Entitlements = Json<paths['/api/orgs/{slug}/entitlements']['get']>;
export type ApiToken = Json<paths['/api/orgs/{slug}/api-tokens']['get']>['tokens'][number];
export type CreatedApiToken = Json<paths['/api/orgs/{slug}/api-tokens']['post']>;
export type Project = Json<paths['/api/me/projects']['get']>['projects'][number];
export type ShareList = Json<paths['/api/projects/{slug}/shares']['get']>;
export type Share = ShareList['shares'][number];
export type PendingShare = ShareList['pending'][number];
export type CapabilityReference = Json<paths['/api/capabilities/reference']['get']>;
export type Profile = Json<paths['/api/profile']['get']>;

export type OrgRole = Member['role'];
export type Role = OrgDetail['role'];
export type ShareRole = Share['role'];
export type Scope = ApiToken['scopes'][number];

export const ORG_ROLES: readonly OrgRole[] = ['org_admin', 'member', 'app_user'];
export const SHARE_ROLES: readonly ShareRole[] = ['viewer', 'editor'];
/**
 * The scopes a person's API token may carry: never a service's own (fleet:worker, fleet:secrets, llm:use,
 * mcp:audit, app_key:access, app_http:use, app_invite:use, app_ai:manage; ADR 0015)
 * nor one only a person's own sign-in carries (pulls:merge; ADR 0030).
 */
export type TokenScope = Exclude<
  Scope,
  | 'fleet:worker'
  | 'fleet:secrets'
  | 'llm:use'
  | 'mcp:audit'
  | 'app_key:access'
  | 'app_http:use'
  | 'app_invite:use'
  | 'app_ai:manage'
  | 'pulls:merge'
>;
export const SCOPES: readonly TokenScope[] = [
  'projects:read',
  'projects:write',
  'pipeline:run',
  'mcp:read',
  'mcp:write',
  'org:read',
  'board:work',
  'board:new-project',
  'apps:write',
];
